<select #comboBox
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [class.combo-box-required]="required" [disabled]="disabled" [hidden]="!visible" [tabindex]="tabindex"
  [(ngModel)]="selectedValue" (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()">
  <ng-template ngFor let-item [ngForOf]="model.mediumList">
    <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
  </ng-template>
</select>
